// extracted by mini-css-extract-plugin
export var addButton = "_y-g";
export var cartCardSlider = "_y-c";
export var cartContainer = "_y-17";
export var cartPreview = "_y-16";
export var cartTotal = "_y-1c";
export var chartContainer = "_y-1u";
export var chartLoading = "_y-1v";
export var checkoutButton = "_y-1i";
export var checkoutButtonContainer = "_y-1b";
export var checkoutContainer = "_y-1k";
export var checkoutPreview = "_y-1j";
export var coveragePreview = "_y-z";
export var dark = "_y-15";
export var editorStyleIcon = "_y-w";
export var errorText = "_y-1s";
export var fakeCheckoutCheckbox = "_y-1q";
export var fakeCheckoutContainer = "_y-1m";
export var fakeCheckoutImage = "_y-1n";
export var fakeCheckoutTextContainer = "_y-1o";
export var fakeCheckoutTitle = "_y-1p";
export var fakeProduct = "_y-1d";
export var fakeProductImage = "_y-1f";
export var fakeProductInfo = "_y-1g";
export var fakeProductPrice = "_y-1h";
export var fakeRedoToggle = "_y-1e";
export var fullCartContainer = "_y-19";
export var fullCartHeader = "_y-18";
export var fullWidth = "_y-0";
export var generalSettingsToggle = "_y-f";
export var hoverable = "_y-x";
export var icon = "_y-1";
export var iconButtonContainer = "_y-1t";
export var light = "_y-13";
export var medium = "_y-14";
export var modalDescription = "_y-l";
export var modalLeftButton = "_y-k";
export var navigateIcon = "_y-y";
export var newSplitModal = "_y-j";
export var payNowButton = "_y-1l";
export var previewLink = "_y-2";
export var previewStyleSelector = "_y-10";
export var previewStyleSelectorSizer = "_y-11";
export var pricingSettingBlock = "_y-1r";
export var quarterCartContainer = "_y-1a";
export var richTextEditor = "_y-u";
export var richTextLabel = "_y-v";
export var selected = "_y-t";
export var selectedSplitType = "_y-p";
export var sidebarContent = "_y-9";
export var sidebarContentSection = "_y-a";
export var sidebarPaddedRow = "_y-d";
export var sidebarSectionHeader = "_y-7";
export var sidebarSectionTitle = "_y-8";
export var sidebarSettingRow = "_y-b";
export var sidebarStyleSelector = "_y-e";
export var skeletonBlock = "_y-12";
export var splitContent = "_y-q";
export var splitContentContainer = "_y-5";
export var splitFooterContainer = "_y-r";
export var splitFormActions = "_y-i";
export var splitHeaderContainer = "_y-h";
export var splitName = "_y-3";
export var splitPage = "_y-4";
export var splitSidebarContainer = "_y-6";
export var splitTypeContainer = "_y-m";
export var splitTypeDescription = "_y-o";
export var splitTypeSelection = "_y-n";
export var treatmentNameButton = "_y-s";